<template>
    <v-container fluid grid-list-sm>
        <v-subheader>
            <v-icon class="mr-1" color="teal">format_list_bulleted</v-icon>
            待办事项
        </v-subheader>
        <v-divider color="lightgrey"/>
        <v-layout row wrap>
            <v-flex xs6 sm4 md2 lg2>
                <v-btn flat large
                       to="/papr/index?statusId=await">
                    <v-badge color="red" overlap>
                        <template v-slot:badge>
                            <span>{{pendingPapers.total}}</span>
                        </template>
                        <v-icon large color="primary">description</v-icon>
                    </v-badge>
                    待审核论文
                </v-btn>
            </v-flex>

          <v-flex xs6 sm4 md2 lg2>
            <v-btn flat large
                   to="/ol-ctra/index?statusId=dept_await">
              <v-badge color="red" overlap>
                <template v-slot:badge>
                  <span>{{pendingOlCtra.total}}</span>
                </template>
                <v-icon large color="orange">forum</v-icon>
              </v-badge>
              待审核合同
            </v-btn>
          </v-flex>

          <v-flex xs6 sm4 md2 lg2>
            <v-btn flat large
                   to="/agmt/index?statusId=dept_await">
              <v-badge color="red" overlap>
                <template v-slot:badge>
                  <span>{{pendingAgmt.total}}</span>
                </template>
                <v-icon large color="orange">domain</v-icon>
              </v-badge>
              待审核合作协议
            </v-btn>
          </v-flex>

          <v-flex xs6 sm3 md2 lg2>
            <v-btn flat large
                   to="/seal/index?statusId=dept_await">
              <v-badge color="red" overlap>
                <template v-slot:badge>
                  <span>{{pendingSeal.total}}</span>
                </template>
                <v-icon large color="orange">domain</v-icon>
              </v-badge>
              待审核用印申请
            </v-btn>
          </v-flex>
        </v-layout>

        <v-subheader>
            <v-icon class="mr-1" color="teal">bar_chart</v-icon>
            统计图表
        </v-subheader>
        <v-divider color="lightgrey"/>

        <v-layout row wrap>
            <!--  科研规模年度统计 -->
            <v-flex xs12 sm12 md6 lg4 d-flex>
                <v-card flat>
                    <v-card-text>
                        <contract-by-year/>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md6 lg4 d-flex>
                <v-card flat>
                    <v-card-text class="text-xs-center">
                        <fund-by-year/>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md6 lg4 d-flex>
                <v-card flat>
                    <v-card-text>
                        <nsfc-by-year/>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12>
                <paper-count-by-level-and-index/>
            </v-flex>

            <v-flex xs6 sm6 md3 lg2>
                <v-card flat>
                    <v-card-title class="text-xs-center">
                        <v-icon medium color="orange darken-2" class="mr-1">fas fa-envelope</v-icon>
                        <span class="subheading">知识产权申请</span>
                    </v-card-title>
                    <property-table uri="/api/inte/report/count/appl/by/type"></property-table>
                </v-card>
            </v-flex>

            <v-flex xs6 sm6 md3 lg2>
                <v-card flat>
                    <v-card-title class="text-xs-center">
                        <v-icon medium color="yellow darken-2" class="mr-1">fas fa-certificate</v-icon>
                        <span class="subheading">知识产权授权</span>
                    </v-card-title>
                    <property-table uri="/api/inte/report/count/granted/by/type"></property-table>
                </v-card>
            </v-flex>

            <v-flex xs6 sm6 md3 lg2>
                <v-card flat>
                    <v-card-title class="text-xs-center">
                        <v-icon medium color="blue darken-2" class="mr-1">fas fa-book</v-icon>
                        <span class="subheading">论著</span>
                    </v-card-title>
                    <property-table uri="/api/book/report/count/by/type"/>
                </v-card>
            </v-flex>

            <v-flex xs6 sm6 md3 lg2>
                <v-card flat>
                    <v-card-title class="text-xs-center">
                        <v-icon medium color="green darken-2" class="mr-1">fas fa-trophy</v-icon>
                        <span class="subheading">奖励</span>
                    </v-card-title>
                    <property-table uri="/api/awar/report/count/by/level"/>
                </v-card>
            </v-flex>

            <v-flex xs6 sm6 md3 lg2>
                <v-card flat>
                    <v-card-title class="text-xs-center">
                        <v-icon medium color="pink darken-2" class="mr-1">fas fa-building</v-icon>
                        <span class="subheading">科研平台</span>
                    </v-card-title>
                    <property-table uri="/api/proj/report/lab/count/by/type"></property-table>
                </v-card>
            </v-flex>

            <v-flex xs6 sm6 md3 lg2>
                <v-card flat>
                    <v-card-title class="text-xs-center">
                        <v-icon medium color="green darken-2" class="mr-1">fas fa-users</v-icon>
                        <span class="subheading">科研团队</span>
                    </v-card-title>
                    <property-table uri="/api/proj/report/team/count/by/type"></property-table>
                </v-card>
            </v-flex>

        </v-layout>
    </v-container>
</template>
<script>

    import FundByYear from '../proj/rept/FundByYear'
    import NsfcByYear from '../proj/rept/NsfcByYear'
    import ContractByYear from '../proj/rept/ContractByYear'

    import PaperCountByLevelAndIndex from '../papr/rept/CountByLevelAndIndex'

    import PropertyTable from '../global/PropertyTable'

    const pendingPaprUrl = '/api/papr/paper';
    const pendingOlCtraUrl = '/api/ol-ctra/contract';
    const pendingAgmt = '/api/agmt/agreement';
    const pendingSealUri =  '/api/seal/quick';

    export default {
        components: {
            ContractByYear,
            FundByYear,
            NsfcByYear,
            PropertyTable,
            PaperCountByLevelAndIndex
        },
        data() {
            return {
                pendingPapers: {total: '?'},
                pendingOlCtra: {total: '?'},
                pendingAgmt: {total: '?'},
                pendingSeal: {total: '?'}
            }
        },
        created() {
            // 加载审核状态
          this.axios.all([
            this.axios.get(pendingPaprUrl, {params: {statusId: 'await', page: 0, limit: 1,}}),
            this.axios.get(pendingOlCtraUrl, {params: {statusId: 'dept_await', page: 0, limit: 1,}}),
            this.axios.get(pendingAgmt, {params: {statusId: 'dept_await', page: 0, limit: 1,}}),
            this.axios.get(pendingSealUri, {params: {statusId: 'dept_await', page: 0, limit: 1,}})
          ]).then(
              this.axios.spread((rspPaper ,rspOlCtra, rspAgmt, rspSeal) => {
                        this.pendingPapers = rspPaper.data;
                        this.pendingOlCtra = rspOlCtra.data;
                        this.pendingAgmt = rspAgmt.data;
                        this.pendingSeal = rspSeal.data
                    }
                )
              )
        },
    }
</script>
